import { Inject, Injectable, isDevMode } from '@angular/core';
import { CbreLogger, CbreLoggerToken } from '@cbre/logger';
import { GtagCreateEvent, GtagDownloadEvent } from '@shared/services/gtag-event.model';

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
declare const gtag: any;

interface GtagData {
  event_category: string;
  event_label: string;
  value: number;
}

@Injectable({ providedIn: 'root' })
export class GtagEventService {
  private readonly isDev: boolean;

  constructor(@Inject(CbreLoggerToken) private logger: CbreLogger) {
    this.isDev = isDevMode();
  }

  onDownloadGtag({ downloadType, reportType, entity, downloadTime }: GtagDownloadEvent) {
    if (!this.isDev) {
      const eventType = 'download';
      const gtagData = {
        event_category: this.formatCategory(reportType),
        event_label: `[${downloadType}] ${entity}`,
        value: downloadTime,
      };

      this.gtag(eventType, gtagData);
      this.miqLogger(eventType, gtagData);
    }
  }

  /**
   * Create gtag create event.
   *
   * @param category
   * @param label
   * @param value i.e. page ID, record ID, etc
   */
  onCreateGtag({ category, label, value }: GtagCreateEvent) {
    if (!this.isDev) {
      const eventType = 'create';
      const gtagData = {
        event_category: this.formatCategory(category),
        event_label: label,
        value,
      };
      this.gtag(eventType, gtagData);
      this.miqLogger(eventType, gtagData);
    }
  }

  private formatCategory(category: string): string {
    return category.toLowerCase().replace(/(\s|\.|,|-|\/)+/g, '_');
  }

  private gtag(_eventType: 'create' | 'download', _gtagData: GtagData) {
    // TODO: google analytics is getting upgraded and it's causing issues around miq.
    // commenting for now
    // gtag('event', eventType, gtagData);
  }

  private miqLogger(eventName: 'create' | 'download', gtagData: GtagData) {
    this.logger.info({ eventName, ...gtagData });
  }
}
